const faIso = {
  prefix: 'fal',
  iconName: 'iso',
  icon: [
    512,
    512,
    [],
    'f11c',
    'M366 208c-19.6 0-31.7 17.1-31.7 46.8S346.4 303 366 303 397.6 284.4 397.6 254.7 385.6 208 366 208zm100.3-82.8l-420.5 0c-5.1 0-9.2 4.1-9.2 9.2l0 243.3c0 5.1 4.1 9.2 9.2 9.2l420.5 0c5.1 0 9.2-4.1 9.2-9.2l0-243.3c0-5.1-4.1-9.2-9.2-9.2zm-347.1 212l-43.2 0 0-163.4 43.2 0 0 163.4zm88 3c-20.6 0-44.2-7.5-61.8-23.4l24.6-29.7c11.6 9.3 26.1 15.8 38.2 15.8 13.1 0 18.6-4.3 18.6-11.6 0-7.8-8.3-10.3-22.1-15.8l-20.4-8.5c-17.6-7-32.9-21.9-32.9-45.5 0-27.9 25.1-50.8 60.8-50.8 18.6 0 39.2 7 54.3 21.9l-21.6 27.1c-11.1-7.8-20.6-11.8-32.7-11.8-10.6 0-17.1 3.8-17.1 11.1 0 7.8 9.3 10.6 24.1 16.3l19.9 7.8c20.4 8 31.9 22.1 31.9 44.7 0 27.6-23.1 52.3-63.8 52.3zm158.8 0c-45.2 0-75.9-31.7-75.9-85.5s30.7-83.9 75.9-83.9 75.9 30.4 75.9 83.9c0 53.8-30.7 85.5-75.9 85.5z',
  ],
};
export default faIso;
